module.exports = __webpack_public_path__ + "img/fondo-banner-principal.4cf5eaf9.png";